import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import * as i0 from "@angular/core";
var ThreadSafeService = /** @class */ (function () {
    function ThreadSafeService() {
        this.variableSubject = new BehaviorSubject(new ComponentState('default', [], false));
        this.variable$ = this.variableSubject.asObservable();
    }
    ThreadSafeService.prototype.getVariable = function () {
        // console.log(`(TSS ${this.variableSubject.getValue().componentName}) getVariable`);
        return this.variableSubject.getValue();
    };
    ThreadSafeService.prototype.setSubComponentsIdsList = function (subComponentIds, id) {
        // console.log(
        //   `(TSS ${
        //     this.variableSubject.getValue().componentName
        //   }) setSubComponentsIdsList: ${subComponentIds}`
        // );
        if (id === void 0) { id = undefined; }
        var current = this.getVariable();
        current.subComponentIdsList = subComponentIds;
        current.initialized = true;
        this.variableSubject.next(current);
    };
    ThreadSafeService.prototype.setSubComponentLoaded = function (subComponentId) {
        // console.log(
        //   `(TSS ${this.variableSubject.getValue().componentName}) setSubComponentLoaded: ${subComponentId}`
        // );
        var current = this.getVariable();
        current.markSubComponetLoaded(subComponentId);
        this.variableSubject.next(current);
    };
    ThreadSafeService.prototype.setComponentDataLoaded = function () {
        // console.log(
        //   `(TSS ${this.variableSubject.getValue().componentName}) setComponentDataLoaded`
        // );
        var current = this.getVariable();
        current.setComponentDataLoaded(true);
        this.variableSubject.next(current);
    };
    ThreadSafeService.prototype.setName = function (name) {
        var current = this.getVariable();
        current.componentName = name;
        this.variableSubject.next(current);
    };
    ThreadSafeService.prototype.getId = function () {
        return this.getVariable().id;
    };
    ThreadSafeService.prototype.setId = function (id) {
        var current = this.getVariable();
        current.id = id;
        this.variableSubject.next(current);
    };
    ThreadSafeService.ɵfac = function ThreadSafeService_Factory(t) { return new (t || ThreadSafeService)(); };
    ThreadSafeService.ɵprov = i0.ɵɵdefineInjectable({ token: ThreadSafeService, factory: ThreadSafeService.ɵfac });
    return ThreadSafeService;
}());
export { ThreadSafeService };
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ThreadSafeService, [{
        type: Injectable
    }], null, null); })();
var ComponentState = /** @class */ (function () {
    function ComponentState(componentName, subComponentIdsList, componentDataLoaded, id) {
        if (id === void 0) { id = undefined; }
        this.componentName = componentName;
        this.subComponentIdsList = subComponentIdsList;
        this.componentDataLoaded = componentDataLoaded;
        this.id = id;
        this.initialized = false;
        if (id == undefined) {
            this.id = this.generateGUID();
        }
        else {
            this.id = id;
        }
    }
    ComponentState.prototype.markSubComponetLoaded = function (subComponentId) {
        this.subComponentIdsList = this.subComponentIdsList.filter(function (item) { return item !== subComponentId; });
    };
    ComponentState.prototype.allSubComponentsLoaded = function () {
        return this.initialized && this.subComponentIdsList.length == 0;
    };
    ComponentState.prototype.setComponentDataLoaded = function (value) {
        this.componentDataLoaded = value;
    };
    ComponentState.prototype.doneLoading = function () {
        return this.componentDataLoaded && this.allSubComponentsLoaded();
    };
    ComponentState.prototype.generateGUID = function () {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = (Math.random() * 16) | 0, v = c === 'x' ? r : (r & 0x3) | 0x8;
            return v.toString(16);
        });
    };
    return ComponentState;
}());
export { ComponentState };
//# sourceMappingURL=thread-safe-component-state.service.js.map